export default __webpack_public_path__ + "static/media/daggerdao_logo.b1de509a.png";